import { FamilyHome } from "../FamilyHome.jsx";

function ChemFamilySeo() {
  return (
    <>
      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "0 0 12px" }}>
        Chemistry as a buildable structure
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Most chemistry resources treat the periodic table as facts to memorize
        and reactions as recipes to follow. The students who actually understand
        chemistry treat it as a structure with rules — periodicity is a
        consequence of electron shell-filling, the noble gases are inert for
        a reason, ionic bonds form from specific electronegativity differences.
        NerdChem games are built around that structural view: the rules are
        the game, and you learn them by playing within them.
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        Three games, three angles on chemistry
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Periodic Quest drills the periodic table by repeated recall — atomic
        numbers, group, period, mass. ChemForge has you build atoms from
        protons, neutrons, and electrons, learning isotopes and ions through
        the construction itself. MoleForge has you bond atoms into molecules —
        every level builds toward benzene, the ring topology Kekulé proposed
        in 1865 from a dream of snakes biting their tails. Three different
        constructions of the same domain, each one teaching what the others
        can't.
      </p>
    </>
  );
}

export default function ChemHome() {
  return <FamilyHome familyId="chem" seoContent={<ChemFamilySeo />} />;
}
